import {defineAsyncComponent} from "vue";

export const menuPanels: Record<string, any> = {
    custom_dropdown: defineAsyncComponent(() => import("./PanelCustomDropdown.vue")),
    dropdown_content1: defineAsyncComponent(() => import("./PanelCustomDropdown.vue")),
    dropdown_sub_categories1: defineAsyncComponent(() => import("./PanelCustomDropdown.vue")),
    dropdown_sub_categories2: defineAsyncComponent(() => import("./PanelCustomDropdown.vue")),

    mega_with_sub_categories1: defineAsyncComponent(() => import("./PanelMegaSubCats1.vue")),
    mega_with_sub_categories2: defineAsyncComponent(() => import("./PanelMegaSubCats2.vue")),
    mega_with_content1: defineAsyncComponent(() => import("./PanelMegaContent1.vue")),
    mega_with_content2: defineAsyncComponent(() => import("./PanelMegaContent2.vue")),
};
